module.exports = __webpack_public_path__ + "static/media/anandM.d5e707c6.jpg";